import { addOrgDataToNavbar } from '~src/navbar';

export const updateUiOnUserChange = async () => {
  await addOrgDataToNavbar();
};
